module.exports = __webpack_public_path__ + "img/search2.a98dd1df.png";